import ParameterValidator from '@mvps-genesis/parameter-validator';

/*
 *--------------------------------------------------------------------------
 * Email Suggestion
 *--------------------------------------------------------------------------
 *
 * Class to Suggest ".com" email addresses to users who enter ".con"
 *
 */

export default class EmailSuggestion {

	/**
	 * The element being validated.
	 *
	 * @prop {ParameterValidator}
	 * @private
	 */
	#validator;

	/**
	 * Constructor of `EmailSuggestion`
	 * @param  {ElementList} elements
	 */
	constructor (elements = '[name="Address_Email"], [name="ShipEmail"], [name="BillEmail"], input#l-Create_Customer_LoginEmail') {
		this.#validator = new ParameterValidator(this);

		/**
		 * The Email Suggestion Elements (inputs)
		 * @prop {ElementList}
		 */
		this.elements = this.#validator.isElementList('elements', elements);

		this.classes = {
			parent: 'js-email-validation-parent',
			suggestion: {
				base: 'g-email-validation-suggestion',
				hidden: 'g-email-validation-suggestion--hidden',
				identifier: 'js-email-validation-suggestion',
				suggestion: 'g-email-validation-suggestion--email'
			}
		};

		// Bind Events
		this.bindEvents();
	}

	/**
	 * Binds events to the email elements
	 */
	bindEvents () {
		for (const element of this.elements) {
			this.addValidationElement(element);
			this.onChange(element);
			element.addEventListener('change', () => this.onChange(element));
		}
	}

	addValidationElement (element) {
		if (!element.parentNode) {
			return;
		}

		element.parentNode.classList.add('js-email-validation-parent');
		const container = document.createElement('button');
		container.type = 'button';
		container.classList.add(this.classes.suggestion.identifier, this.classes.suggestion.base, this.classes.suggestion.hidden);
		container.addEventListener('click', () => this.onClick(element));
		element.parentNode.appendChild(container);
	}

	onClick (element) {
		element.value = element.getAttribute('data-suggestion');
		element.dispatchEvent(new Event('change', {bubbles: true}));
	}

	onChange (element) {
		const suggestionElem = element.parentNode?.querySelector?.(`.${this.classes.suggestion.identifier}`);
		if (!suggestionElem) {
			return;
		}

		const elemValue = element.value;
		if (!elemValue.endsWith('.con')) {
			suggestionElem.classList.add(this.classes.suggestion.hidden);
			return;
		}

		const suggestion = elemValue.replace('.con', '.com');
		suggestionElem.innerHTML = `Did you mean? <span class="${this.classes.suggestion.suggestion}">${suggestion}</span>`;
		element.setAttribute('data-suggestion', suggestion);
		suggestionElem.classList.remove(this.classes.suggestion.hidden);
	}
}
